import { useEffect, useState } from 'react';
import { AuthContext } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [token, setToken] = useState(null);
  const [loadingPreloader, setLoadingPreloader] = useState(true);
  const navigate = useNavigate();

  const handleLogin = (data) => {
    setUsuario(data.user);
    setToken(data.token);

    localStorage.setItem("user", JSON.stringify(data.user));
    localStorage.setItem("token", data.token);
    setLoadingPreloader(false);

    const permisos = data.user.permisos || [];
    if (permisos.includes("menu_dashboard")) {
      navigate("/admin", { replace: true });
    } else if (permisos.includes("menu_sales")) {
      navigate("/admin/ventas", { replace: true });
    }else if (permisos.includes("menu_reported_web")) {
      navigate("/admin/reportadas", { replace: true });
    }else if (permisos.includes("menu_welcome_web")) {
      navigate("/admin/bienvenida", { replace: true });
    }else if (permisos.includes("leads")) {
      navigate("/admin/leads", { replace: true });
    }else if (permisos.includes("menu_recruitment")) {
      navigate("/admin/reclutamiento", { replace: true });
    }else if (permisos.includes("menu_rrhh")) {
      navigate("/admin/rrhh", { replace: true });
    } else {
      navigate("/no-autorizado", { replace: true });
    }
  };

  const handleLogout = () => {
    setUsuario(null);
    setToken(null);
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/", { replace: true });
  };

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error?.response?.status;
        const message = error?.response?.data?.error || "";
        if (
          status === 401 && (
            message.includes("Token expirado") ||
            message.includes("Token inválido") ||
            message.includes("Usuario dado de baja")
          )
        ) {
          console.warn("🔒 Sesión finalizada por:", message);
          handleLogout();
        }
        return Promise.reject(error);
      }
    );
    return () => axios.interceptors.response.eject(interceptor);
  }, []);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const storedToken = localStorage.getItem("token");
    if (storedUser && storedToken) {
      setUsuario(JSON.parse(storedUser));
      setToken(storedToken);
    }
    setLoadingPreloader(false);
  }, []);

  return (
    <AuthContext.Provider
      value={{ usuario, token, setUsuario, setToken, handleLogin, handleLogout, loadingPreloader }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;